export default "/images/circle-chevron-up-solid.svg?000b5b67b5c9e969ab36bd3ab5042679";